import { IHeaderSectionsAreaData } from "src/typings/section-area-data";
import { RendererBase } from "../../shared/renderer-base";

export class HeaderSectionsAreaRenderer extends RendererBase<IHeaderSectionsAreaData> {

    protected override createNewInternal(): HTMLElement {
        const element = document.createElement("header");
        element.setAttribute("data-layout-element", "");
        element.setAttribute("data-section-area", "");
        element.id = "headers-area";

        return element;
    }

    protected override renderInternal(element: HTMLElement, data: IHeaderSectionsAreaData): HTMLElement {
        this.renderedDocument.body.classList.add("with-header");

        element.setAttribute("data-order-static-view", JSON.stringify(data.staticViewSectionsOrder));
        element.setAttribute("data-order-scroll-view", JSON.stringify(data.scrollViewSectionsOrder));

        return element;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override getContentSelectorsInternal(element: HTMLElement): string[] {
        return [];
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected cleanupInternal(element: HTMLElement): void {
        // ToDo
    }

}
